exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-shape-title-area {\n    box-sizing: content-box;\n    position: absolute;\n    content: \"\";\n    top: 0%;\n    right: 0%;\n    bottom: 80%;\n    left: 0%;\n    border: none;\n    -webkit-border-top-left-radius: 50% 40%;\n    -webkit-border-top-right-radius: 50% 40%;\n    border-top-left-radius: 50% 40%;\n    border-top-right-radius: 50% 40%;\n    text-overflow: clip;\n    text-shadow: none;\n    z-index: -1;\n    padding: 40px;\n}\n\n.background-shape-title-area::after {\n    box-sizing: content-box;\n    position: absolute;\n    content: \"\";\n    top: 28%;\n    right: -3.7%;\n    bottom: 0%;\n    left: -3.7%;\n    border: none;\n    -webkit-border-top-left-radius: 64% 940%;\n    -webkit-border-top-right-radius: 64% 940%;\n    border-top-left-radius: 64% 940%;\n    border-top-right-radius: 64% 940%;\n    text-overflow: clip;\n    text-shadow: none;\n    z-index: -1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/css/paper-set.component.css
// module id = ../../../../../src/app/css/paper-set.component.css
// module chunks = main